import {
  ADD_GROUP,
  ADD_GROUP_SUCCESS,
  ADD_GROUP_FAILED,
  RESET_GROUP_CREATED,
  FETCH_GROUPS,
  FETCH_GROUPS_SUCCESS,
  FETCH_GROUPS_FAILED,
  FETCH_GROUP_PEOPLE,
  FETCH_GROUP_PEOPLE_SUCCESS,
  FETCH_GROUP_PEOPLE_FAILED,
  RESET_PERSON_ADDED_TO_GROUP,
  ADD_PERSON_TO_GROUP_FAILED,
  ADD_PERSON_TO_GROUP_SUCCESS,
  ADD_PERSON_TO_GROUP,
  REMOVE_PERSON_FROM_GROUP,
  REMOVE_PERSON_FROM_GROUP_SUCCESS,
  REMOVE_PERSON_FROM_GROUP_FAILED,
  RESET_PERSON_REMOVED_FROM_GROUP,
  RENAME_GROUP,
  RESET_GROUP_PAGE,
} from "./types";
import { SIGN_OUT } from "../auth/types";
const initialState = {
  addingGroup: false,
  groupCreated: false,
  addingPeopleToGroup: false,
  personAddedToGroup: false,
  fetchingGroups: true,
  groups: [],
  systemGroups: [],
  subGroups: [],
  numberOfGroups: 0,
  fetchingGroupPeople: false,
  groupPeople: [],
  totalNumberOfGroupPeople: 0,
  fetchedGroupId: "",
  fetchedGroupPeople: false,
  removingPersonFromGroup: false,
  personRemovedFromGroup: false,
  groupPeoplePage: 1,
  groupPeopleLimit: 250,
  groupName: "",
  groupType: "",
  parentGroupId: "",
  parentGroupName: "",
  numberOfGroupPeople: 0,
  query: "",
};

export default (state = initialState, action) => {
  switch (action.type) {
    case SIGN_OUT:
      return {
        ...initialState,
      };
    case ADD_GROUP:
      return {
        ...state,
        addingGroup: true,
      };
    case ADD_GROUP_SUCCESS:
      return {
        ...state,
        addingGroup: false,
        groupCreated: true,
      };
    case ADD_GROUP_FAILED:
      return {
        ...state,
        addingGroup: false,
      };
    case RESET_GROUP_CREATED:
      return {
        ...state,
        groupCreated: false,
      };
    case REMOVE_PERSON_FROM_GROUP:
      return {
        ...state,
        removingPersonFromGroup: true,
      };
    case REMOVE_PERSON_FROM_GROUP_SUCCESS:
      return {
        ...state,
        removingPersonFromGroup: false,
        personRemovedFromGroup: true,
      };
    case REMOVE_PERSON_FROM_GROUP_FAILED:
      return {
        ...state,
        removingPersonFromGroup: false,
      };
    case RESET_PERSON_REMOVED_FROM_GROUP:
      return {
        ...state,
        personRemovedFromGroup: false,
      };
    case ADD_PERSON_TO_GROUP:
      return {
        ...state,
        addingPeopleToGroup: true,
      };
    case ADD_PERSON_TO_GROUP_SUCCESS:
      return {
        ...state,
        addingPeopleToGroup: false,
        personAddedToGroup: true,
      };
    case ADD_PERSON_TO_GROUP_FAILED:
      return {
        ...state,
        addingPeopleToGroup: false,
      };
    case RESET_PERSON_ADDED_TO_GROUP:
      return {
        ...state,
        personAddedToGroup: false,
      };
    case FETCH_GROUPS:
      return {
        ...state,
        fetchingGroups: true,
      };

    case FETCH_GROUPS_FAILED:
      return {
        ...state,
        fetchingGroups: false,
        groups: !action.groupsFound ? [] : state.groups,
      };

    case FETCH_GROUP_PEOPLE:
      return {
        ...state,
        fetchingGroupPeople: true,
        fetchedGroupPeople: false,
        query: action.query,
      };
    case FETCH_GROUPS_SUCCESS: {
      const groups = action.payload.data.data ? action.payload.data.data : [];
      const systemGroups = groups.filter((item) => item.type === "system");
      const group = systemGroups.find((el) => el.uuid === state.parentGroupId);
      return {
        ...state,
        parentGroupName: group ? group.name : "",
        fetchingGroups: false,
        subGroups: groups.filter((item) => item.parent_id !== undefined),
        groups: groups.filter(
          (item) => item.type === "custom" && !item.parent_id
        ),
        systemGroups,
      };
    }
    case FETCH_GROUP_PEOPLE_SUCCESS:
      const { data } = action.payload;
      const parentGroupId =
        data && data.type !== "system" ? data.parent_id : "";
      const group = state.systemGroups.find((el) => el.uuid === parentGroupId);
      return {
        ...state,
        fetchingGroupPeople: false,
        groupPeople:
          action.payload.data && action.payload.data.persons
            ? action.payload.data.persons
            : [],
        numberOfGroupPeople: action.payload.data
          ? action.payload.data.item
            ? action.payload.data.items
            : 0
          : 0,
        totalNumberOfGroupPeople: action.payload.data
          ? action.payload.data.total
            ? action.payload.data.total
            : 0
          : 0,
        fetchedGroupId: action.fetchedGroupId,
        groupType: data ? data.type : "",
        parentGroupId,
        parentGroupName: group ? group.name : "",
        groupName: action.payload.data
          ? action.payload.data.groupName
            ? action.payload.data.groupName
            : ""
          : "",
        groupPeoplePage: action.groupPeoplePage,
        fetchedGroupPeople: true,
      };
    case FETCH_GROUP_PEOPLE_FAILED:
      return {
        ...state,
        fetchingGroupPeople: false,
        // groupPeople: state.groupPeople||[],
        numberOfGroupPeople: 0,
        totalNumberOfGroupPeople: 0,
        fetchedGroupId: action.fetchedGroupId,
        groupName: "",
        fetchedGroupPeople: true,
      };
    case RENAME_GROUP:
      return {
        ...state,
        groupName:
          action.id === state.fetchedGroupId ? action.name : state.groupName,
      };
    case RESET_GROUP_PAGE:
      return {
        ...state,
        groupPeoplePage: 1,
      };
    default:
      return state;
  }
};
